
import * as directusRuntime$eU5wNa70fG from '/builds/proverky/proverky.net/frontend/node_modules/.pnpm/@nuxt+image@1.7.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5_rollup@4.46.2/node_modules/@nuxt/image/dist/runtime/providers/directus'
import * as ipxRuntime$29j8Jrg3CV from '/builds/proverky/proverky.net/frontend/node_modules/.pnpm/@nuxt+image@1.7.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5_rollup@4.46.2/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['directus']: { provider: directusRuntime$eU5wNa70fG, defaults: {"baseURL":"https://admin.proverky.net/assets/","modifiers":{"format":"webp"}} },
  ['ipx']: { provider: ipxRuntime$29j8Jrg3CV, defaults: {} }
}
        